/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGetABExperimentsResponseSchema } from '../../entities/schemas/GetABExperimentsResponseSchema';

export type TGetAbExperimentsModel = IModel<IGetAbExperimentsRequest, TGetAbExperimentsResponse>;

export interface IGetAbExperimentsRequest {
  /** Список названий экспериметов **/
  experiments?: string[] | null;
}

export type TGetAbExperimentsResponse = IGetAbExperimentsResponse200 | IGetAbExperimentsResponse400;

export interface IGetAbExperimentsResponse200 extends IModelResponse<IGetAbExperimentsResponse> {
  statusCode: 200;
}

export interface IGetAbExperimentsResponse400 extends IModelResponse<IGetAbExperimentsResponseError> {
  statusCode: 400;
}

export interface IGetAbExperimentsResponse {
  data: IGetABExperimentsResponseSchema;
  status: EStatus;
}

export interface IGetAbExperimentsResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetAbExperimentsResponse | IGetAbExperimentsResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetAbExperimentsResponse): TResponse200;
  400(response: IGetAbExperimentsResponseError): TResponse400;
}
